import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { InviteToMeetingModule } from '@app/account/shared/invite-to-meeting/invite-to-meeting.module';
import { MeetingFormWrapperModule } from '@app/core/components/meeting-form-wrapper/meeting-form-wrapper.module';
import { AlertModule } from '@core/components/alert/alert.module';
import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MeetingsTitleModule } from '@core/components/meeting-title/meetings-title.module';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { CoreModule } from '@core/core.module';
import { ZonedDatePipe } from '@core/pipes/zoned-time-to-utc.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { UserServiceContractCheckoutDialogModule } from '@shared/checkout-wizards/user-service-contract-checkout-dialog';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { ClipboardModule } from 'ngx-clipboard';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';
import { PipesModule } from '../../pipes/pipes.module';
import { ModalModule } from '../modal/modal.module';
import { MeetingCardComponent } from './meeting-card.component';

@NgModule({
  declarations: [MeetingCardComponent],
  imports: [
    CommonModule,
    DateFnsModule,
    RouterModule,
    TranslateModule,
    ClipboardModule,
    PipesModule,
    ModalModule,
    InviteToMeetingModule,
    MobileModalModule,
    OnUiCoverModule,
    OnUiCardMenuModule,
    CoreModule,
    OnUiButtonModule,
    MeetingFormWrapperModule,
    BookmarkComponent,
    SubscribeComponent,
    MeetingsTitleModule,
    RatingComponent,
    AlertModule,
    ZonedDatePipe,
    UserServiceContractCheckoutDialogModule,
    IconComponent,
    AuthorInfoComponent,
  ],
  exports: [MeetingCardComponent],
})
export class MeetingsCardModule {}
